import styled from '@/styles';

// The wide Lifecycle tables scroll sideways on a laptop screen. macOS hides
// its overlay scrollbar until a scroll starts, so a table wider than the
// screen looked cut off with no way to reach the rest (bug hunt 13 BH-1301,
// Jira 61228). A styled scrollbar is always drawn in Chrome and Safari.
//
// scrollbar-width is for Firefox only: Chrome 121+ and Safari 18.2+ ignore
// every ::-webkit-scrollbar rule once it is set to anything but auto, which
// brought the hidden overlay scrollbar back (review D-01).
export const scrollStyles = {
  overflowX: 'auto',
  '&::-webkit-scrollbar': { height: '10px' },
  '&::-webkit-scrollbar-track': { background: '#F4F4F4' },
  '&::-webkit-scrollbar-thumb': { background: '#C4C4C4', borderRadius: '5px' },
  '@supports not selector(::-webkit-scrollbar)': { scrollbarWidth: 'thin' },
} as const;

export const Scroll = styled('div', scrollStyles);

export default Scroll;
